import {
  InferableComponentEnhancerWithProps,
  MapDispatchToPropsParam,
  MapStateToPropsParam,
  connect as connectRedux,
} from 'react-redux'

type MapResultToPromise<T> = T extends (...args: infer U) => infer R
  ? (...args: U) => Promise<R>
  : T

type ResolveLoops<DispatchProps> = {
  [Property in keyof DispatchProps]: MapResultToPromise<DispatchProps[Property]>
}

export const connect = <
  TStateProps = unknown,
  TDispatchProps = unknown,
  TOwnProps = unknown,
  State = unknown,
>(
  mapStateToProps: MapStateToPropsParam<TStateProps, TOwnProps, State>,
  mapDispatchToProps: MapDispatchToPropsParam<TDispatchProps, TOwnProps>
): InferableComponentEnhancerWithProps<TStateProps & ResolveLoops<TDispatchProps>, TOwnProps> =>
  connectRedux(mapStateToProps, mapDispatchToProps)
